import { render, staticRenderFns } from "./remove.html?vue&type=template&id=092fbd48&"
import script from "./Remove.js?vue&type=script&lang=js&"
export * from "./Remove.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports